import { type Dispatch, type SetStateAction, createContext } from 'react';

export interface TokenStateType {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  isLoggedIn: boolean;
}

interface TokenContextType {
  tokens: TokenStateType;
  setTokens: Dispatch<SetStateAction<TokenStateType>>;
}

const TokenContext = createContext<TokenContextType>({
  tokens: { accessToken: '', refreshToken: '', isLoggedIn: false, idToken: '' },
  setTokens: () => {},
});

export default TokenContext;
